import React, {useMemo} from 'react';
import {useIntl} from 'react-intl';
import cn from 'classnames';

import {useProducts} from 'coreHooks';

import {useGeneralProvider} from 'brandComponents/_app-config/GeneralProvider';
import Link from 'brandComponents/Link';
import Picture from 'brandComponents/Picture';
import {PRODUCT_IMAGES_SETTINGS, ViewType} from 'brandConstants';

import {IProductColorSelectionProps} from './IProductColorSelection';
import messages from './messages';

import styles from './ProductColorSelection.module.scss';

const ProductColorSelection = ({product}: IProductColorSelectionProps) => {
	const intl = useIntl();
	const {managerRepository} = useGeneralProvider();

	const otherColorsIdList = useMemo(() => {
		const colorVariationIds = product?.getVariationGroupIds();

		if (colorVariationIds.length <= 1) {
			return [product.getProductId()];
		}

		return colorVariationIds;
	}, [product]);

	const otherColorsProducts = useProducts(otherColorsIdList);

	return (
		<div className={styles['product-color-selection']}>
			<div className={styles['product-color-selection__info-wrapper']}>
				<span className={styles['product-color-selection__info-title']}>
					{intl.formatMessage(messages.colorName)}
				</span>
				<span className={styles['product-color-selection__info-color']}>
					{product.getColorDescription()}
				</span>
			</div>
			<div className={styles['product-color-selection__image-wrapper']}>
				{otherColorsProducts.map((colorProductItem, i) => {
					const image = colorProductItem.getProductImage({
						viewType: ViewType.ZOOM,
						transformationObject: PRODUCT_IMAGES_SETTINGS.productOtherColors
					});
					const activeProduct = colorProductItem.getProductId() === product.getProductId();
					const url = colorProductItem.getProductUrl();

					const handleClick = () => {
						managerRepository.getUiMgr().resetSizeSelectorSelectedPid();
					};

					return (
						<Link
							to={url}
							onClick={handleClick}
							id={colorProductItem.getProductId()}
							key={`${colorProductItem.getProductId()}-${i}`}
						>
							<Picture
								image={image}
								classNames={cn(
									styles['product-color-selection__image'],
									{[styles['product-color-selection__image-active']]: activeProduct}
								)}
							/>
						</Link>
					);
				})}
			</div>
		</div>
	);
};

export default ProductColorSelection;
